import React, {Fragment, useState} from "react";

import './BulkLocationEditorHours.css'

function BulkLocationEditorSpecialHours({updateLocationPatchSection, locationPatchSpecialHours}) {

  const _state = locationPatchSpecialHours.map(specialHourBlock => ({
    ...specialHourBlock,
    openTime: (specialHourBlock.openTime === null ? "" : specialHourBlock.openTime), // Reach input values should be an empty string for empty values, null throws an error
    closeTime: (specialHourBlock.closeTime === null ? "" : specialHourBlock.closeTime) // Reach input values should be an empty string for empty values, null throws an error
  }));

  const [specialHoursModel, setSpecialHoursModel] = useState(_state);

  const cleanSpecialHoursForPatch = (specialHoursModel) => {
    const cleaned = specialHoursModel.filter(specialHourBlock => {
      return !!specialHourBlock.date && (
        (!!specialHourBlock.openTime && !!specialHourBlock.closeTime) ||
        specialHourBlock.isClosed ||
        specialHourBlock.open24Hours
      )
    })
    .map(specialHourBlock => ({
      ...specialHourBlock,
      openTime: (specialHourBlock.openTime === "" ? null : specialHourBlock.openTime),
      closeTime: (specialHourBlock.closeTime === "" ? null : specialHourBlock.closeTime)
    }));

    return cleaned;
  };

  const addSpecialHourBlock = () => {
    const updatedSpecialHoursModel = specialHoursModel.concat([
        {
          date: "",
          openTime: "",
          closeTime: "",
          isClosed: false,
          open24Hours: false
        }
      ]);

    setSpecialHoursModel(updatedSpecialHoursModel);
    updateLocationPatchSection(cleanSpecialHoursForPatch(updatedSpecialHoursModel))
  };

  const removeSpecialHourBlock = (specialHourBlockIndex) => () => {
    const updatedSpecialHoursModel = specialHoursModel.filter((item, index) => specialHourBlockIndex !== index);

    setSpecialHoursModel(updatedSpecialHoursModel);
    updateLocationPatchSection(cleanSpecialHoursForPatch(updatedSpecialHoursModel))
  };

  const setSpecialHourBlockOpenTime = (specialHourBlockIndex) => (event) => {
    const updatedSpecialHoursModel = specialHoursModel.map((specialHourBlock, index) => {
      if (specialHourBlockIndex === index) {
        return {
          ...specialHourBlock,
          openTime: event.target.value
        }
      } else {
        return specialHourBlock
      }
    });

    setSpecialHoursModel(updatedSpecialHoursModel);
    updateLocationPatchSection(cleanSpecialHoursForPatch(updatedSpecialHoursModel))
  };

  const setSpecialHourBlockDate = (specialHourBlockIndex) => (event) => {
    const updatedSpecialHoursModel = specialHoursModel.map((specialHourBlock, index) => {
      if (specialHourBlockIndex === index) {
        return {
          ...specialHourBlock,
          date: event.target.value
        }
      } else {
        return specialHourBlock
      }
    });

    setSpecialHoursModel(updatedSpecialHoursModel);
    updateLocationPatchSection(cleanSpecialHoursForPatch(updatedSpecialHoursModel))
  };

  const setSpecialHourBlockCloseTime = (specialHourBlockIndex) => (event) => {
    const updatedSpecialHoursModel = specialHoursModel.map((specialHourBlock, index) => {
      if (specialHourBlockIndex === index) {
        return {
          ...specialHourBlock,
          closeTime: event.target.value
        }
      } else {
        return specialHourBlock
      }
    });

    setSpecialHoursModel(updatedSpecialHoursModel);
    updateLocationPatchSection(cleanSpecialHoursForPatch(updatedSpecialHoursModel))
  };

  const setOpen24hours = (specialHourBlockIndex) => (event) => {
    const open24Hours = event.target.checked;

    const updatedSpecialHoursModel = specialHoursModel.map((specialHourBlock, index) => {
      if (specialHourBlockIndex === index) {
        return {
          ...specialHourBlock,
          openTime: open24Hours ? "00:00" : "",
          closeTime: open24Hours ? "24:00" : "",
          isClosed: false,
          open24Hours
        }
      } else {
        return specialHourBlock
      }
    });

    setSpecialHoursModel(updatedSpecialHoursModel);
    updateLocationPatchSection(cleanSpecialHoursForPatch(updatedSpecialHoursModel))
  };

  const setIsClosed = (specialHourBlockIndex) => (event) => {
    const isClosed = event.target.checked;

    const updatedSpecialHoursModel = specialHoursModel.map((specialHourBlock, index) => {
        if (specialHourBlockIndex === index) {
          return {
            ...specialHourBlock,
            openTime: "",
            closeTime: "",
            isClosed,
            open24Hours: false
          }
        } else {
          return specialHourBlock
        }
      });

    setSpecialHoursModel(updatedSpecialHoursModel);
    updateLocationPatchSection(cleanSpecialHoursForPatch(updatedSpecialHoursModel))
  };

  return <div className="card-spacer-top card-spacer-bottom">
    <h5>Special/ Holiday hours</h5>
    <div className="card-spacer-bottom">Only selected dates will be updated</div>
    <form className="form-inline card-spacer-top">
      <table className="bulkLocationEditorSpecialHours">
        <tbody>
        {specialHoursModel.map((specialHourBlock, specialHourBlockIndex) => {
          return <Fragment key={specialHourBlockIndex}>
            <tr className="card-spacer-top">
              <td>
                <label>
                  <button type="button" className="btn btn-secondary" onClick={removeSpecialHourBlock(specialHourBlockIndex)}>
                    <i className="fas fa-trash-alt" />
                  </button>
                </label>
              </td>
              <td colSpan={2}>
                <div>
                  <input className="form-control" type="date" value={specialHourBlock.date} onChange={setSpecialHourBlockDate(specialHourBlockIndex)}/>
                </div>
              </td>
              <td />
              <td />
              <td />
            </tr>
            <tr>
              <td />
              <td>
                from
              </td>
              <td>
                <input className="form-control" style={{"width": "100%"}} disabled={specialHourBlock.open24Hours || specialHourBlock.isClosed} type="time" value={specialHourBlock.openTime} onChange={setSpecialHourBlockOpenTime(specialHourBlockIndex)} />
              </td>
              <td>
                {" "}to <input className="form-control" disabled={specialHourBlock.open24Hours || specialHourBlock.isClosed} type="time" value={specialHourBlock.closeTime} onChange={setSpecialHourBlockCloseTime(specialHourBlockIndex)} />
              </td>
              <td>
                <div className="custom-control custom-checkbox control-spacer-left">
                  <input type="checkbox" id={"specialopen-" + specialHourBlockIndex} className="custom-control-input" disabled={specialHourBlock.isClosed} defaultChecked={specialHourBlock.open24Hours} onClick={setOpen24hours(specialHourBlockIndex)}/>
                  <label className="custom-control-label" htmlFor={"specialopen-" + specialHourBlockIndex}>Open 24 Hours</label>
                </div>
              </td>
              <td>
                <div className="custom-control custom-checkbox control-spacer-left">
                  <input type="checkbox" id={"specialclosed-" + specialHourBlockIndex} className="custom-control-input" disabled={specialHourBlock.open24Hours} defaultChecked={specialHourBlock.isClosed} onClick={setIsClosed(specialHourBlockIndex)}/>
                  <label className="custom-control-label" htmlFor={"specialclosed-" + specialHourBlockIndex}>Closed</label>
                </div>
              </td>
            </tr>
          </Fragment>
        })}
        </tbody>
      </table>
    </form>
    <button type="button" className="btn btn-secondary" onClick={addSpecialHourBlock}>
      <i className="far fa-plus" />
    </button>
  </div>
}

export default BulkLocationEditorSpecialHours